import React, { useState } from 'react';

function SecurityPage() {
  const [security, setSecurity] = useState({
    twoFactorAuth: true,
    lastPasswordChange: '2023-05-15',
    loginAlerts: true,
    trustedDevices: [
      { name: 'MacBook Pro', lastUsed: '2023-06-10', location: 'San Francisco, CA' },
      { name: 'iPhone 13', lastUsed: '2023-06-12', location: 'San Francisco, CA' }
    ]
  });

  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [passwordError, setPasswordError] = useState('');

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordForm({
      ...passwordForm,
      [name]: value
    });
  };
  const handlePasswordSubmit = (e) => {
    e.preventDefault();

    // Simple validation
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      setPasswordError('New passwords do not match');
      return;
    }

    if (passwordForm.newPassword.length < 8) {
      setPasswordError('Password must be at least 8 characters');
      return;
    }

    // Password change simulation
    setSecurity({
      ...security,
      lastPasswordChange: new Date().toISOString().split('T')[0]
    });

    setPasswordError('');
    setIsChangingPassword(false);
    setPasswordForm({
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    });
  };
 const toggleTwoFactor = () => {
    setSecurity({
      ...security,
      twoFactorAuth: !security.twoFactorAuth
    });
  };

  const toggleLoginAlerts = () => {
    setSecurity({
      ...security,
      loginAlerts: !security.loginAlerts
    });
  };

  const removeDevice = (index) => {
    const updatedDevices = [...security.trustedDevices];
    updatedDevices.splice(index, 1);
    setSecurity({
      ...security,
      trustedDevices: updatedDevices
    });
  };
  return (
    <>
      <div className="account-header">
        <h2>Security Settings</h2>
      </div>

      <div className="security-section">
        <h3>Password</h3>
        <div className="detail-group">
          <span className="detail-label">Last changed:</span>
          <span className="detail-value">{security.lastPasswordChange}</span>
        </div>

        {!isChangingPassword ? (
          <button
            className="edit-button"
            onClick={() => setIsChangingPassword(true)}
          >
            Change Password
          </button>
        ) : (
          <form onSubmit={handlePasswordSubmit} className="account-form">
            {passwordError && <div className="error-message">{passwordError}</div>}

            <div className="form-group">
              <label htmlFor="currentPassword">Current Password</label>
              <input
                type="password"
                id="currentPassword"
                name="currentPassword"
                value={passwordForm.currentPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                value={passwordForm.newPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={passwordForm.confirmPassword}
                onChange={handlePasswordChange}
                required
              />
            </div>

            <div className="button-group">
              <button type="submit" className="save-button">Update Password</button>
              <button
                type="button"
                className="cancel-button"
                onClick={() => {
                  setIsChangingPassword(false);
                  setPasswordError('');
                }}
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
      <div className="security-section">
        <h3>Two-Factor Authentication</h3>
        <div className="toggle-option">
          <div>
            <p>Require a security code in addition to your password when signing in</p>
            <p className="option-status">
              Status: <span className={security.twoFactorAuth ? 'enabled' : 'disabled'}>
                {security.twoFactorAuth ? 'Enabled' : 'Disabled'}
              </span>
            </p>
          </div>
          <button
            className={`toggle-button ${security.twoFactorAuth ? 'on' : 'off'}`}
            onClick={toggleTwoFactor}
          >
            {security.twoFactorAuth ? 'Disable' : 'Enable'}
          </button>
        </div>
      </div>

      <div className="security-section">
        <h3>Login Alerts</h3>
        <div className="toggle-option">
          <div>
            <p>Receive email alerts when your account is accessed from a new device or location</p>
            <p className="option-status">
              Status: <span className={security.loginAlerts ? 'enabled' : 'disabled'}>
                {security.loginAlerts ? 'Enabled' : 'Disabled'}
              </span>
            </p>
          </div>
          <button
            className={`toggle-button ${security.loginAlerts ? 'on' : 'off'}`}
            onClick={toggleLoginAlerts}
          >
            {security.loginAlerts ? 'Disable' : 'Enable'}
          </button>
        </div>
      </div>

      <div className="security-section">
        <h3>Trusted Devices</h3>
        <div className="trusted-devices">
          {security.trustedDevices.map((device, index) => (
            <div key={index} className="device-card">
              <div className="device-info">
                <h4>{device.name}</h4>
                <p>Last used: {device.lastUsed}</p>
                <p>Location: {device.location}</p>
              </div>
              <button
                className="remove-button"
                onClick={() => removeDevice(index)}
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default SecurityPage;
